export default __webpack_public_path__ + "static/media/function2.8a56c3ee.mp3";